import styled from "@emotion/styled";
import { FormGrid } from "mesh-component-library";

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const HiddenGoogleMap = styled.div`
  display: none;
`;

export const StyledFormGrid = styled(FormGrid)`
  background-color: #ffffff;
  padding: 8px;
`;
